import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2021 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { TextTooltip } from '../tooltip/textTooltip/textTooltip';
import { isTouchDevices } from '../utils/platformUtils';
import { StyledInfoList } from './infoListStyles';
export var EmbersInfoList = function EmbersInfoList(_ref) {
  var info = _ref.info,
    _ref$tooltipProps = _ref.tooltipProps,
    tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledInfoList, {
    className: classnames('EmbersInfoList-root', className)
  }, info.map(function (i, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "EmbersInfoList-item",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('info-label', {
        'info-label-withTooltip': i.tooltip
      })
    }, /*#__PURE__*/React.createElement(TextTooltip, {
      typographyProps: {
        variant: 'subtitle3'
      },
      spacing: 0.5,
      textToIconSpacing: 4,
      tooltipProps: i.tooltip ? _objectSpread(_objectSpread({
        title: i.tooltip,
        placement: isTouchDevices() ? 'bottom-end' : 'right-start',
        type: 'info'
      }, tooltipProps), i.tooltipProps || {}) : undefined
    }, i.label)), /*#__PURE__*/React.createElement("div", {
      className: "info-colon"
    }, ":"), /*#__PURE__*/React.createElement("div", {
      className: "info-content"
    }, i.content || ''));
  }));
};